/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable brace-style */
/* eslint-disable import/no-unresolved */
/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
/* eslint-disable prefer-template */
import React, {
    useEffect, useCallback, useContext, useState
} from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { WizardPage, WizardPageTemplate, wizardProps } from 'gw-portals-wizard-react';
import { useDataRefresh, ViewModelForm, ViewModelServiceContext } from 'gw-portals-viewmodel-react';
import { withAuthenticationContext, useAuthentication } from 'gw-digital-auth-react';
import { useDependencies } from 'gw-portals-dependency-react';
import { withRouter, useHistory } from 'react-router-dom';
import { messages as commonMessages } from 'gw-platform-translations';
import { readViewModelValue } from 'gw-jutro-adapters-react';
import { ModalNextProvider } from '@jutro/components';
import Claim from 'gw-capability-fnol-common-react/models/Claim';
import Address from 'gw-capability-fnol-common-react/models/Address';
import appConfig from 'app-config';
import { TranslatorContext } from '@jutro/locale';
import {
    isAttested
} from 'sasria-capability-fnol-common-react/Validations/ValidationUtil';
import metadata from './SasriaFNOLSummaryPage.metadata.json5';
import summaryStyles from './SasriaFNOLSummaryPage.module.scss';
import SasriaAdjusterContentPage from './Component/SasriaAdjusterContent';
import SasriaAddNotePopup from './Component/SasriaAddNotePopup';
import SasriaAdditionalContact from './Component/SasriaAdditionalContact';
import messages from '../../gw-capability-fnol-common-react/FNOL.messages';

function SasriaFNOLSummaryPage(props) {
    const translator = useContext(TranslatorContext);
    const { name: agentName } = useAuthentication();
    const { FNOLService } = useDependencies('FNOLService');
    const { ClaimService } = useDependencies('ClaimService');
    const [isLoading, setIsLoading] = useState(false);
    const [loadingMessage, setLoadingMessage] = useState('');
    const [showLoader, setShowLoader] = useState(false);
    const [showAdditionalContact, setShowAdditionalContact] = useState(false);
    const [stpMessage, setStpMessage] = useState('');
    const [attested, setAttested] = useState(false);
    const {
        wizardData: claimVM,
        updateWizardData,
        history: {
            location: { state = {} }
        },
        authHeader
    } = props;

    const history = useHistory();
    const viewModelService = useContext(ViewModelServiceContext);
    const [popupNotesVM, updatePopupNotesVM] = useState(null);
    const newNoteViewModelObj = (initialData) => {
        return {
            note: viewModelService.create(
                initialData.note,
                'cc',
                'edge.capabilities.note.dto.NoteDTO'
            )
        };
    };

    const handleAdditionalContact = useCallback(() => {
        setShowAdditionalContact(true);
    }, []);

    const handleSTPAttestation = useCallback((value) => {
        _.set(claimVM, 'stpClaimAttested_EXT.value', value);
        setAttested(value);
    }, [claimVM]);

    useEffect(() => {
        const attestationString = 'I Agent_User of Agent_Company hereby certify that all the information and documents provided in respect of cover, item at risk, circumstances of loss are Sasria related,  proof of premium payment , loss quantum and banking details are true and correct.\n\rI agree that the acceptance of liability, manner or extent of indemnification, as the case may be, envisaged on this claim is based on the facts available to us at this stage. Should new facts come to our attention which affect our decision to accept liability or on the manner or extent of the indemnity owing, as the case may be, we reserve our rights to withdraw our acceptance of liability, claim restitution or take whatever steps may be appropriate under the circumstances.';
        const agentUserReplace = attestationString.replace('Agent_User', agentName);
        const agentCompanyReplace = agentUserReplace.replace('Agent_Company', claimVM.policyData_EXT.agentName_Ext.value);
        setStpMessage(agentCompanyReplace);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getWhereLocation = useCallback(() => {
        if (_.isUndefined(claimVM.lossLocation)) {
            return false;
        }
        const unitComplexBranch = claimVM.lossLocation.unitorComplexorBranch.value;
        let address = '';
        if (
            !_.isEmpty(claimVM.lossLocation.value)
            && claimVM.lossLocation.city.value
            && claimVM.lossLocation.addressLine1.value
            && claimVM.lossLocation.suburb.value
            && claimVM.lossLocation.postalCode.value

        ) {
            address = `${claimVM.lossLocation.addressLine1.value},
            ${claimVM.lossLocation.suburb.value},
            ${claimVM.lossLocation.city.value},
            ${claimVM.lossLocation.state.value.code},
            ${claimVM.lossLocation.postalCode.value}`;
        }
        else if (
            !_.isEmpty(claimVM.lossLocation.value)
            && claimVM.lossLocation.city.value
            && claimVM.lossLocation.addressLine1.value
            && claimVM.lossLocation.postalCode.value
        ) {
            address = `${claimVM.lossLocation.addressLine1.value},
            ${claimVM.lossLocation.city.value},
            ${claimVM.lossLocation.state.value.code},
            ${claimVM.lossLocation.postalCode.value}`;
        }
        else if (!_.isEmpty(claimVM.lossLocation.value)
            && claimVM.lossLocation.city.value
            && claimVM.lossLocation.addressLine1.value
        ) {
            address = `${claimVM.lossLocation.addressLine1.value},
            ${claimVM.lossLocation.city.value},
            ${claimVM.lossLocation.state.value.code}`;
        }
        else if (!_.isEmpty(claimVM.lossLocation.value)) {
            address = `${claimVM.lossLocation.city.value},
            ${claimVM.lossLocation.state.value.code},
            ${claimVM.lossLocation.country.value.code}`;
        }
        else address = '';
        if (!_.isUndefined(unitComplexBranch)) {
            address = unitComplexBranch + ',' + address;
        }
        return address;
    }, [claimVM]);

    const getLossEstimateValue = useCallback(
        () => {
            if (_.isUndefined(claimVM.policy)) {
                return false;
            }
            const policy = claimVM;
            const policyType = policy;
            const classCode = claimVM.policyData_EXT.sasriaClassCode_EXT.value;

            const prefix = classCode.substring(0, classCode.indexOf(','));
            if (prefix === 'CW') {
                const contractInciArray = claimVM.contractWorksIncidentArray_EXT.value;
                const vehicleInciArray = claimVM.vehicleIncidentArray_EXT.value;
                const propertIncidentArray = claimVM.propertyIncidentArray_EXT.value;
                let totalIncidentAmt = Number(0.00);
                if (!_.isUndefined(vehicleInciArray) && !_.isEmpty(vehicleInciArray)) {
                    vehicleInciArray.forEach((incident) => {
                        if (incident.haveLossEstimate === true) {
                            const { lossEstimateInclVATValue, haveLossEstimate } = incident;
                            if (haveLossEstimate === true) {
                                totalIncidentAmt += parseFloat(lossEstimateInclVATValue);
                            }
                        }
                    });
                }
                if (!_.isUndefined(contractInciArray) && !_.isEmpty(contractInciArray)) {
                    contractInciArray.forEach((incident) => {
                        const { lossEstimateInclVATValue, haveLossEstimate } = incident;
                        if (haveLossEstimate === true) {
                            totalIncidentAmt += parseFloat(lossEstimateInclVATValue);
                        }
                    });
                }
                if (!_.isUndefined(propertIncidentArray) && !_.isEmpty(propertIncidentArray)) {
                    propertIncidentArray.forEach((incident) => {
                        const { lossEstimateInclVATValue, haveLossEstimate } = incident;
                        if (haveLossEstimate === true) {
                            totalIncidentAmt += parseFloat(lossEstimateInclVATValue);
                        }
                    });
                }
                return totalIncidentAmt === 0.00 ? 'Unknown' : (`R${totalIncidentAmt.toFixed(2)}`);
            }
            if (prefix === 'BI') {
                const biIncidentArray = claimVM.businessInterruptionIncidents_EXT.value;
                let totalAmt = 0.00;
                biIncidentArray.forEach((incident) => {
                    const { lossEstimateInclVATValue, haveLossEstimate } = incident;
                    if (haveLossEstimate === true) {
                        totalAmt += parseFloat(lossEstimateInclVATValue);
                    }
                });
                return totalAmt === 0.00 ? 'Unknown' : (`R${totalAmt.toFixed(2)}`);
            }

            if (prefix === 'M1' || prefix === 'M2' || prefix === 'M3' || prefix === 'M4' || prefix === 'M5'
                || prefix === 'M6' || prefix === 'M7' || prefix === 'M8') {
                const vehicleIncidentArray = claimVM.vehicleIncidentArray_EXT.value;
                let totalAmt = 0.00;
                vehicleIncidentArray.forEach((incident) => {
                    const { lossEstimateInclVATValue, haveLossEstimate } = incident;
                    if (haveLossEstimate === true) {
                        totalAmt += parseFloat(lossEstimateInclVATValue);
                    }
                });
                return totalAmt === 0.00 ? 'Unknown' : (`R${totalAmt.toFixed(2)}`);
            }

            if (prefix === 'F1' || prefix === 'F2' || prefix === 'F1T' || prefix === 'FE3' || prefix === 'F4' || prefix === 'GIT' || prefix === 'MON') {
                const propertyInci = claimVM.propertyIncident_EXT.value;
                let lossEst = 0.00;
                const { haveLossEstimate, lossEstimateInclVATValue } = propertyInci;
                if (haveLossEstimate === true) {
                    lossEst = parseFloat(lossEstimateInclVATValue);
                }
                return lossEst === 0.00 ? 'Unknown' : (`R${lossEst.toFixed(2)}`);
            }
            return '';
        },
        [claimVM]
    );
    const onNext = useCallback(() => {
        setIsLoading(true);
        setShowLoader(true);
        // const attested = claimVM.stpClaimAttested_EXT.value;

        // Validation for Express claim.

        if (claimVM.value.sasriaExpressClaimDetails_EXT.isExpressClaimSelected && !isAttested(attested)) {
            return false;
        }

        setLoadingMessage(translator(messages.fnolSubmitClaimDetails));
        return FNOLService.submitClaim_EXT(claimVM.value, authHeader)
            .then((response) => {
                claimVM.value = response;
                const claimNumber = _.get(claimVM.value, 'claimNumber');
                FNOLService.creatingOneinsured_EXt(claimNumber, authHeader);
                const { redirectPath } = state;
                const isSTP = _.get(claimVM.value, 'sasriaExpressClaimDetails_EXT');
                const { isExpressClaimSelected } = isSTP;
                const totalInsuredPaymentSTP = _.get(claimVM.value, 'totalInsuredPayable_EXT');
                let isF4 = false;
                const classCode = claimVM.policyData_EXT.sasriaClassCode_EXT.value;
                const prefix = classCode.substring(0, classCode.indexOf(','));
                if (prefix === 'F4') {
                    isF4 = true;
                }
                return history.push({
                    pathname: `/confirmation/${claimNumber}`,
                    state: {
                        redirectPath: redirectPath,
                        isSTPSelected: isExpressClaimSelected,
                        totalInsuredPayment: totalInsuredPaymentSTP,
                        isF4: isF4
                    }
                });
            })
            .catch(() => {
                ModalNextProvider.showAlert({
                    title: messages.fnolErrorSubmitClaimTitle,
                    message: messages.fnolErrorSubmitClaimMessage,
                    status: 'error',
                    icon: 'mi-error-outline',
                    confirmButtonText: commonMessages.ok
                }).catch(_.noop);
                return false;
            })
            .finally(() => {
                setShowLoader(false);
            });
    }, [claimVM.value, attested, translator, FNOLService, authHeader, state, history]);


    const initializeNotesVM = () => {
        if (!_.isEmpty(claimVM.adjusterNote.value)) {
            const getNotesVM = newNoteViewModelObj({
                note: {
                    claimNumber: claimVM.claimNumber.value,
                    subject: claimVM.adjusterNote.subject.value,
                    body: claimVM.adjusterNote.body.value
                }
            });
            return updatePopupNotesVM(getNotesVM.note);
        }

        const getNotesVM = newNoteViewModelObj({
            note: {
                claimNumber: claimVM.claimNumber.value,
                subject: '',
                body: ''
            }
        });
        return updatePopupNotesVM(getNotesVM.note);
    };

    useEffect(() => {
        initializeNotesVM();
        // execute once
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const showModal = useCallback(
        async (getNotesVM) => {
            const componentProps = {
                title: translator(messages.dialogAddNoteToAdjuster),
                actionBtnLabel: messages.dialogOk,
                cancelBtnLabel: messages.dialogCancel,
                notesVM: getNotesVM,
                viewModelService: viewModelService
            };

            const results = await ModalNextProvider.showModal(
                <SasriaAddNotePopup {...componentProps} />
            );

            return results;
        },
        [translator, viewModelService]
    );

    const updateNoteData = useCallback(
        (noteVM) => {
            setIsLoading(true);
            const claimNumber = _.get(claimVM.value, 'claimNumber');
            return ClaimService.updateClaimNote(claimNumber, noteVM.value, authHeader)
                .then((response) => {
                    _.set(claimVM, 'adjusterNote.value', response);
                    updateWizardData(claimVM);
                    _.set(noteVM, 'value', response);
                    updatePopupNotesVM(noteVM);
                })
                .catch(() => {
                    ModalNextProvider.showAlert({
                        title: messages.fnolNoteErrorHead,
                        message: messages.fnolNoteErrorMessage,
                        status: 'error',
                        icon: 'mi-error-outline',
                        confirmButtonText: commonMessages.ok
                    }).catch(_.noop);
                    return false;
                })
                .finally(() => {
                    setIsLoading(false);
                });
        },
        [claimVM, authHeader, updateWizardData, ClaimService]
    );

    const handleEditNote = useCallback(() => {
        showModal(popupNotesVM).then((updatedVM) => {
            const modifiedVM = viewModelService.clone(updatedVM);
            updateNoteData(modifiedVM);
        }).catch(_.noop);
    }, [popupNotesVM, showModal, updateNoteData, viewModelService]);

    const handleFraudStatement = useCallback(() => {
        ModalNextProvider.showAlert({
            title: 'Fraud Statement',
            message: 'By clicking on “Submit Claim”, you warrant that all information you submit to Sasria on this web portal is true, accurate, and correct, that you have consent to process any third-party personal information, and you undertake to update such information as and when required. You further acknowledge that you will be liable for the consequences which arise from any untrue, inaccurate and/or misleading information knowingly and/or intentionally supplied to Sasria via this web portal.',
            status: 'error',
            icon: 'mi-error-outline',
            confirmButtonText: commonMessages.ok
        }).catch(_.noop);
    }, []);

    const handleDeleteNote = useCallback(() => {
        setIsLoading(true);
        const claimNumber = _.get(claimVM.value, 'claimNumber');
        const noteId = _.get(claimVM.value, 'adjusterNote.publicID');
        return ClaimService.deleteClaimNote(claimNumber, noteId, authHeader)
            .then((response) => {
                _.set(claimVM, 'adjusterNote.value', response);
                updateWizardData(claimVM);
                _.set(popupNotesVM, 'value', response);
                updatePopupNotesVM(popupNotesVM);
            })
            .catch(() => {
                ModalNextProvider.showAlert({
                    title: messages.fnolNoteErrorHead,
                    message: messages.fnolNoteErrorMessage,
                    status: 'error',
                    icon: 'mi-error-outline',
                    confirmButtonText: commonMessages.ok
                }).catch(_.noop);
                return false;
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, [claimVM, authHeader, popupNotesVM, updateWizardData, ClaimService]);

    const saveNoteData = useCallback(
        (noteVM) => {
            setIsLoading(true);
            const claimNumber = _.get(claimVM.value, 'claimNumber');
            return ClaimService.createClaimNote(claimNumber, noteVM.value, authHeader)
                .then((response) => {
                    _.set(claimVM, 'adjusterNote.value', response);
                    updateWizardData(claimVM);
                    _.set(noteVM, 'value', response);
                    updatePopupNotesVM(noteVM);
                })
                .catch(() => {
                    ModalNextProvider.showAlert({
                        title: messages.fnolNoteErrorHead,
                        message: messages.fnolNoteErrorMessage,
                        status: 'error',
                        icon: 'mi-error-outline',
                        confirmButtonText: commonMessages.ok
                    }).catch(_.noop);
                    return false;
                })
                .finally(() => {
                    setIsLoading(false);
                });
        },
        [authHeader, claimVM, updateWizardData, ClaimService]
    );


    const addNotesToAdjuster = useCallback(() => {
        showModal(popupNotesVM).then((updatedVM) => {
            const modifiedVM = viewModelService.clone(updatedVM);
            saveNoteData(modifiedVM);
        }).catch(_.noop);
    }, [popupNotesVM, saveNoteData, showModal, viewModelService]);

    const overrides = {

        addNotebtnDiv: {
            visible: _.isUndefined(claimVM.adjusterNote) ? false : _.isEmpty(claimVM.adjusterNote.value)
        },
        adjusterNoteDiv: {
            visible: _.isUndefined(claimVM.adjusterNote) ? false : !_.isEmpty(claimVM.adjusterNote.value)
        },
        additionalContactBtnDiv: {
            visible: !_.isEmpty(claimVM.adjusterNote.value)
        },
        additionalContact: {
            visible: showAdditionalContact,
            claimVM,
            updateWizardData
        },
        stpAttestationandSummary: {
            visible: claimVM.value.sasriaExpressClaimDetails_EXT.isExpressClaimSelected,
            label: stpMessage,
            value: attested
        },
        expressClaimReimbursement: {
            visible: claimVM.value.sasriaExpressClaimDetails_EXT.isExpressClaimSelected,
            value: claimVM.value.totalAgentPayable_EXT !== 0 ? 'R' + claimVM.value.totalAgentPayable_EXT + '.00' : undefined,
        },
        expressClaimInsuredPayable: {
            visible: claimVM.value.sasriaExpressClaimDetails_EXT.isExpressClaimSelected,
            value: claimVM.value.totalInsuredPayable_EXT !== 0 ? 'R' + claimVM.value.totalInsuredPayable_EXT + '.00' : undefined,
        },
        adjusterContent: {
            handleEditNote,
            handleDeleteNote,
            claimVM
        },

        fnolWhere: {
            value: getWhereLocation()
        },

        fnollossestimate: {
            value: getLossEstimateValue()
        }
    };
    const resolvers = {
        resolveCallbackMap: {
            addNotesToAdjuster: addNotesToAdjuster,
            handleAdditionalContact: handleAdditionalContact,
            handleFraudStatement: handleFraudStatement,
            handleSTPAttestation: handleSTPAttestation,
        },
        resolveComponentMap: {
            adjustercontent: SasriaAdjusterContentPage,
            additionalContact: SasriaAdditionalContact
        },
        resolveClassNameMap: summaryStyles
    };

    const readValue = (id, path) => {
        return readViewModelValue(metadata.pageContent, claimVM, id, path, overrides);
    };

    return (
        <WizardPage
            onNext={onNext}
            template={WizardPageTemplate}
            nextLabel={translator(messages.fnolSubmitClaim)}
        >
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={claimVM}
                overrideProps={overrides}
                onModelChange={updateWizardData}
                callbackMap={resolvers.resolveCallbackMap}
                componentMap={resolvers.resolveComponentMap}
                classNameMap={resolvers.resolveClassNameMap}
                resolveValue={readValue}
            // onValidationChange={onValidate}
            />
        </WizardPage>
    );
}
SasriaFNOLSummaryPage.propTypes = wizardProps;
SasriaFNOLSummaryPage.propTypes = {
    history: PropTypes.shape({
        push: PropTypes.func
    }).isRequired
};
export default withRouter(withAuthenticationContext(SasriaFNOLSummaryPage));
